// ════════════════════════════════════════
// app/courses/ai.tsx
// ════════════════════════════════════════
import { CourseCategoryPage } from '@/components/seo/CourseCategoryPage';
export default function AIPage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס בינה מלאכותית ו-AI',
        metaTitle: 'קורס בינה מלאכותית ו-AI 2025 – איך לבחור נכון | Kursi',
        slug: 'ai',
        metaDescription: 'קורסי AI ובינה מלאכותית 2025 – ChatGPT, Machine Learning, Prompt Engineering. השוואה, צ׳ק-ליסט ודגלים אדומים לבחירת קורס AI מתאים. קבלו 3 המלצות אישיות.',
        subtitle: 'מ-ChatGPT ו-Prompt Engineering ועד Machine Learning ו-LLM — מצאו קורס AI שמתאים לרמה ולמטרה שלכם.',
        chips: ['ChatGPT', 'Prompt Engineering', 'Machine Learning', 'אוטומציה', 'Python', 'Generative AI'],
        chatSeed: 'קורס בינה מלאכותית',
        sections: [
          {
            id: 'goal',
            title: 'איזה סוג קורס AI אתם צריכים?',
            body: 'AI זה לא קורס אחד. יש הבדל גדול בין קורס שימוש בכלים (ChatGPT, Midjourney) לבין קורס פיתוח מודלים (Python, TensorFlow). בחרו לפי המטרה שלכם.',
            bullets: [
              'שימוש בכלי AI: ChatGPT, Claude, Midjourney, Runway',
              'Prompt Engineering: כתיבת הנחיות אפקטיביות',
              'אוטומציה עסקית: Zapier, Make, n8n',
              'Machine Learning: Python, מודלים, נתונים',
              'LLM Engineering: פיתוח על בסיס GPT/Claude API',
            ],
          },
          {
            id: 'update',
            title: 'למה חשוב שהקורס יהיה מעודכן',
            body: 'AI משתנה כל שבוע. קורס משנת 2022 כבר לא רלוונטי. בדקו מתי עודכן לאחרונה ואם המרצה פעיל בתחום.',
            bullets: [
              'בדקו: מתי עודכנו החומרים לאחרונה?',
              'האם הקורס מכסה כלים של 2024–2025?',
              'האם יש עדכונים שוטפים לתלמידים?',
              'האם המרצה פעיל ומפרסם תוכן בתחום?',
            ],
          },
          {
            id: 'practical',
            title: 'מעשי לעומת תיאורטי',
            body: 'קורס AI טוב כולל פרויקטים אמיתיים. לא מספיק לצפות בסרטונים — צריך לבנות, לתרגל ולקבל משוב.',
            bullets: [
              'פרויקטים עם כלי AI אמיתיים',
              'תרגול עם API אמיתיים (OpenAI, Anthropic)',
              'בניית אוטומציות אמיתיות לעסק',
              'פרויקט גמר שאפשר להציג בפורטפוליו',
            ],
          },
        ],
        checklist: [
          'החומרים מעודכנים ל-2024–2025',
          'יש תרגול מעשי ולא רק הסברים',
          'המרצה פעיל בתחום ה-AI',
          'הקורס מכסה כלים שרלוונטיים לצורך שלי',
          'יש קהילה ותמיכה אחרי הקורס',
        ],
        redFlags: [
          'קורס AI משנת 2022 שלא עודכן',
          'תיאוריה בלבד ללא הדגמות על כלים אמיתיים',
          'הבטחות "AI יכפיל לך את ההכנסה מחר"',
          'אין תרגול עצמאי בקורס',
        ],
        faq: [
          { q: 'האם צריך רקע בתכנות ללמוד AI?', a: 'תלוי בסוג הקורס. Prompt Engineering ואוטומציה — לא צריך. Machine Learning ופיתוח מודלים — Python בסיסי יעזור מאוד.' },
          { q: 'האם AI יחליף את העבודה שלי?', a: 'AI ישנה תפקידים, לא בהכרח יחליף. אנשים שלומדים לעבוד עם AI יהיו יותר מבוקשים מאלה שלא.' },
          { q: 'מה הכי שווה ללמוד ב-AI עכשיו?', a: 'Prompt Engineering ואוטומציה עסקית — ביקוש גבוה, זמן לימוד קצר. LLM Engineering — ביקוש גבוה מאוד, דורש יותר זמן.' },
        ],
      }}
    />
  );
}

// ════════════════════════════════════════
// app/courses/real-estate.tsx
// ════════════════════════════════════════
export function RealEstatePage() {
  return (
    <CourseCategoryPage
      config={{
        title: 'קורס נדל"ן',
        metaTitle: 'קורס נדל״ן 2025 – תיווך, השקעות ומשכנתאות | Kursi',
        subtitle: 'תיווך נדל"ן, השקעות, יזמות וייעוץ משכנתאות — מצאו קורס שיקדם אתכם בתחום הנדל"ן.',
        chips: ['תיווך', 'השקעות', 'משכנתאות', 'יזמות', 'נדל"ן בחו"ל', 'התחדשות עירונית'],
        chatSeed: 'קורס נדל"ן',
        sections: [
          {
            id: 'goal',
            title: 'מה המטרה שלכם בנדל"ן?',
            body: 'נדל"ן זה לא תחום אחד. תיווך, השקעות, יזמות ומשכנתאות — כל מסלול שונה לחלוטין. הגדירו מטרה לפני שבוחרים קורס.',
            bullets: [
              'תיווך: רישוי, שיווק ניהול עסקאות',
              'השקעות: ניתוח עסקאות, מינוף, תשואה',
              'יזמות: התחדשות עירונית, תמ"א 38',
              'משכנתאות: מסלולים, מחזור, ייעוץ',
              'נדל"ן בחו"ל: ארה"ב, קפריסין, יוון',
            ],
          },
          {
            id: 'license',
            title: 'רישיון תיווך — מה צריך לדעת',
            body: 'בישראל חובה לעמוד בבחינת הרישוי של משרד המשפטים כדי לעסוק בתיווך. קורסים מוסמכים מכינים לבחינה זו. בדקו שהקורס מוכר רשמית.',
            bullets: [
              'חובה: בחינת רישוי משרד המשפטים',
              'בדקו שהקורס מוכר ומכין לבחינה',
              'הכשרה מעשית עם עסקאות סימולציה',
              'היכרות עם חוזים ומסמכים רשמיים',
            ],
          },
          {
            id: 'market',
            title: 'להבין את שוק הנדל"ן הישראלי',
            body: 'שוק הנדל"ן בישראל ייחודי — מיסוי, חוקים ומגמות שונים מחו"ל. קורס טוב ילמד את המציאות הישראלית ולא רק תיאוריה כללית.',
            bullets: [
              'מיסוי נדל"ן: מס שבח, מס רכישה',
              'חוק התיווך הישראלי',
              'שוק השכירות לעומת בעלות',
              'מגמות שוק עדכניות',
            ],
          },
        ],
        checklist: [
          'הקורס מוכר ומכין לרישיון (לתיווך)',
          'יש תרגול עם חוזים ועסקאות אמיתיות',
          'המרצה פעיל בשוק הנדל"ן',
          'חומר מיסוי מעודכן לשנה הנוכחית',
          'יש קהילה של בוגרים פעילים',
        ],
        redFlags: [
          'הבטחות "מיליונים בנדל"ן תוך שנה"',
          'מרצה שמוכר נכסים שלו דרך הקורס',
          'חומר מיסוי לא מעודכן',
          'אין הכנה לרישיון תיווך (לקורסי תיווך)',
        ],
        faq: [
          { q: 'כמה מרוויח מתווך נדל"ן?', a: 'עמלת תיווך: 2% מערך העסקה + מע"מ. בדירה של 2 מיליון — 40,000₪ עמלה. מתווך פעיל יכול לסגור 2–5 עסקאות בחודש.' },
          { q: 'האם צריך רישיון לעסוק בתיווך?', a: 'כן, בישראל חובה רישיון ממשרד המשפטים. קורסים מוסמכים מכינים לבחינת הרישוי.' },
          { q: 'מה עדיף — השקעה בארץ או בחו"ל?', a: 'תלוי בהון, ברמת סיכון ובזמן. בארץ — מוכר ונגיש. בחו"ל — דורש יועצים מקומיים ומחקר מעמיק.' },
        ],
      }}
    />
  );
}